import React from "react";
import styled from "@emotion/styled";
import { Typography } from "../Typography";

const Wrapper = styled(Typography)`
  margin-bottom: 1rem;
`;

interface ProjectCountProps {
  count: number;
}

export const ProjectCount = ({ count }: ProjectCountProps) => {
  return (
    <Wrapper use="dashboardMicroCopyRegular" as="p">
      {count > 0 ? (
        <>
          <Typography use="dashboardMicroCopyBold" as="span">
            {count}
          </Typography>{" "}
          project{count > 1 && "s"}
        </>
      ) : (
        "no results"
      )}
    </Wrapper>
  );
};
